import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { Order } from '../../../../../models/order.model';
import { getCancellationHistory } from '../../utils/order-details.util';

@Component({
  selector: 'app-order-cancellation-card',
  imports: [DatePipe],
  templateUrl: './order-cancellation-card.component.html',
  styleUrl: './order-cancellation-card.component.scss',
})
export class OrderCancellationCardComponent {
  order = input<Order | null>(null);

  cancellation = computed(() => this.order()?.cancellation ?? null);

  cancelledAt = computed(
    () =>
      this.cancellation()?.requestedAt ??
      getCancellationHistory(this.order())?.transitionedAt,
  );

  cancelledBy = computed(
    () => this.cancellation()?.cancelledByEmployeeName ?? 'Cliente',
  );

  reason = computed(() => this.cancellation()?.reasonDescription ?? null);

  additionalDetails = computed(
    () => this.cancellation()?.additionalDetails?.trim() || null,
  );
}
